import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, onActivated, ref, onMounted } from 'vue'
import { customerAggregationList, customerUnmerge, getItemsBySensitize } from '@/api/customer/index'
import dataConfig from '@/views/customer/commonEnum/dataConfig'
import CosMergeButton from '@/components/CosMergeButton'
import { useRoute } from 'vue-router'
import { DcConfirm, DcMessage } from '@dc-platform/dc-components'
import type { CustomerAggregationItem } from '@/typings/api/customer'
import dayjs from 'dayjs'


const __default__ = { name: 'DcCosCustomerAggregation' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const tableRef = ref()
const orgEnumJson = {
  cos_fbu: '谷仓-销售管理',
  cos_ofbu: '谷仓-海外销售管理',
  cos_lbu: '云途-销售管理'
}
const selectedRows = ref<CustomerAggregationItem[]>([])
const masterCosCenterCode = ref('')
// const masterCosCenterArray = ref('')

const queryForm = ref<any>({})

// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  customerAggregationList({
    ...params,
    masterCosCenterCode: masterCosCenterCode.value
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: CustomerAggregationItem, callBack: (res: any) => void) => {
  getItemsBySensitize({
    cosId: record.cosId
  }).then((res) => {
    callBack(res.data)
  })
}
const clearParams = () => {
  localStorage.setItem('dc-cos-lbu-exclude-keep-alive', '')
  masterCosCenterCode.value = ''
}
// 清除缓存
const clearKeep = () => {
  const code = localStorage.getItem('dc-cos-lbu-exclude-keep-alive')
  if (code && code === route.query.masterCosCenterCode) {
    masterCosCenterCode.value = code
    queryForm.value = {}
    localStorage.removeItem('dc-cos-lbu-exclude-keep-alive')
  }
}
onMounted(() => {
  masterCosCenterCode.value = route.query.masterCosCenterCode as string
  if (!route.query.masterCosCenterCode) {
    queryForm.value.dealTimeStart = dayjs().subtract(30, 'day').format('YYYY/MM/DD 00:00:00')
    queryForm.value.dealTimeEnd = dayjs().format('YYYY/MM/DD 23:59:59')
  }
})
onActivated(() => {
  clearKeep()
})
// 合并客户
const onSelectChange = (selectedRowKeys: string[], rows: CustomerAggregationItem[]) => {
  selectedRows.value = rows
}
// 解绑
const handleUnbind = (row: CustomerAggregationItem) => {
  DcConfirm.warning({
    title: '解绑提示！',
    content: '是否解除绑定',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      customerUnmerge({
        masterCosCenterCodes: [row.masterCosCenterCode]
      }).then((res) => {
        DcMessage.success('解绑成功')
        success()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/customer/customerAggregation/view',
    query: ['cosId', 'status', 'appId'],
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '集团客户代码', dataIndex: 'cosCenterCode', width: 150 },
  { title: 'MDM客户编号', dataIndex: 'mdmCode', width: 150 },
  { title: '所属品牌', dataIndex: 'brand' },
  { title: '内部签约主体', dataIndex: 'ourContractSubject' },
  { title: '签约主体', dataIndex: 'cusContractSubject' },
  { title: '所属组织', dataIndex: 'appId', dicData: dataConfig.orgEnum },
  { title: '业务系统', dataIndex: 'sys', dicData: dataConfig.sysEnum },
  { title: '客户编号', dataIndex: 'customerNumber' },
  { title: '客户代码', dataIndex: 'customerCode' },
  { title: '客户类型', dataIndex: 'customerType', dicData: dataConfig.customerTypeEnum },
  {
    title: '冻结状态',
    dataIndex: 'freezeStatus',
    dicData: [
      { label: '正常', value: 1 },
      { label: '冻结', value: 2 }
    ]
  },
  { title: '联系人', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '成交时间', dataIndex: 'dealTime', width: 190 },
  { title: '客户状态', dataIndex: 'status', dicData: dataConfig.customerStatus },
  { title: '是否与其他客户合并', dataIndex: 'mergeFlag', dicData: dataConfig.mergeFlag, width: 150 },
  { title: '客户负责人', dataIndex: 'sellerName' },
  {
    title: '操作',
    dataIndex: 'action',
    width: 120,
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "cosId",
            "row-selection": { onChange: onSelectChange },
            serials: "",
            columns: columns.value,
            tableId: "CustomerAggregation",
            onFetch: fetch,
            onMask: showMask,
            onSearch: clearParams,
            search: queryForm.value,
            "onUpdate:search": _cache[14] || (_cache[14] = ($event: any) => ((queryForm).value = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "content",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "cosCenterCode",
                    label: "集团客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.cosCenterCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.cosCenterCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "mdmCode",
                    label: "MDM客户编号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.mdmCode,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.mdmCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "brand",
                    label: "所属品牌"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.value.brand,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.value.brand) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).brandEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "cusContractSubject",
                    label: "签约主体"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.cusContractSubject,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.cusContractSubject) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "appId",
                    label: "所属组织"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.value.appId,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.value.appId) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).orgEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "sys",
                    label: "业务系统"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.value.sys,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.value.sys) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).sysEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "content",
                    label: "客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.customerCode,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.value.customerCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "contactName",
                    label: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.contactName,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.value.contactName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "contactMobile",
                    label: "手机号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.contactMobile,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.value.contactMobile) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "成交时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.value.dealTimeStart,
                        "onUpdate:startTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.value.dealTimeStart) = $event)),
                        endTime: queryForm.value.dealTimeEnd,
                        "onUpdate:endTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.value.dealTimeEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "是否与其他客户合并" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.value.mergeFlag,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.value.mergeFlag) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).mergeFlag
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "seller",
                    label: "客户负责人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.value.seller,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.value.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'appId')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text
                  ? text
                      .split(',')
                      .map((k) => orgEnumJson[k] || k)
                      .join(',')
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleUnbind(record)),
                        disabled: record.mergeFlag === 1 ? false : true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("解绑")
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])), [
                        [_directive_permission, 'customer_aggregation_unbind_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(CosMergeButton), {
                data: selectedRows.value,
                appId: "customer",
                onSuccess: success,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("合并")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'customer_aggregation_merge_btn']
              ])
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})